import type { TestimonialItem } from './types';

interface TestimonialsSectionProps {
  testimonials: TestimonialItem[];
  activeTestimonial: number;
  onTestimonialChange: (index: number) => void;
  isVisible: boolean;
  sectionRef: React.RefObject<HTMLElement | null>;
  name?: string;
  description?: string;
  background?: string;
  nameColor?: string;
  descriptionColor?: string;
}

export default function TestimonialsSection({
  testimonials,
  activeTestimonial,
  onTestimonialChange,
  isVisible,
  sectionRef,
  name = 'Khách Hàng Nói Gì Về Chúng Tôi',
  description,
  background,
  nameColor,
  descriptionColor
}: TestimonialsSectionProps) {
  const backgroundStyle = background
    ? {
        backgroundImage: background.startsWith('http') || background.startsWith('/')
          ? `url(${background})`
          : undefined,
        backgroundColor: background.startsWith('http') || background.startsWith('/') ? undefined : background,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    : undefined;

  return (
    <section 
      ref={sectionRef}
      data-section="testimonials"
      className={`py-24 ${!background ? 'bg-[#2a4b7c]' : ''}`}
      style={backgroundStyle}
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <h2 
            className="text-4xl font-bold mb-4"
            style={{ color: nameColor || 'white' }}
          >
            {name}
          </h2>
          {description && (
            <p 
              className="text-lg max-w-2xl mx-auto"
              style={{ color: descriptionColor || '#d1d5db' }}
            >
              {description}
            </p>
          )}
        </div>
        <div className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <div className="bg-white rounded-xl p-10 shadow-xl">
            <div className="flex gap-1 mb-6">
              {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-xl text-[#00c897]"></i>
              ))}
            </div>
            <p className="text-xl text-[#333] leading-relaxed mb-8">
              "{testimonials[activeTestimonial].quote}"
            </p>
            <div className="flex items-center gap-4">
              <img
                src={testimonials[activeTestimonial].avatar}
                alt={testimonials[activeTestimonial].name}
                className="w-14 h-14 rounded-full object-cover object-top"
              />
              <div>
                <div className="font-bold text-[#333]">{testimonials[activeTestimonial].name}</div>
                <div className="text-sm text-[#4b5563]">
                  {testimonials[activeTestimonial].position} - {testimonials[activeTestimonial].company}
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => onTestimonialChange(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === activeTestimonial ? 'bg-[#00c897] w-8' : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

